import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "description", "type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useField } from 'formik';
import styled, { css } from 'styled-components';
import { CheckIcon } from '@yoweb/ui/components/Icon/CheckIcon';
import { Text } from '@yoweb/ui/components/typography';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { getColor, getSpace, getRadii, getDuration } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * A Formik controlled Checkbox component.
 */
var Checkbox = function Checkbox(props) {
  var _useField = useField(_objectSpread({
    type: props.type || 'checkbox'
  }, props)),
      _useField2 = _slicedToArray(_useField, 1),
      field = _useField2[0];

  return /*#__PURE__*/_jsx(CheckboxIntakeUI, _objectSpread(_objectSpread({}, field), props));
};
/**
 * A checkbox component.
 */


export var CheckboxIntakeUI = function CheckboxIntakeUI(_ref) {
  var children = _ref.children,
      description = _ref.description,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Wrap, {
    htmlFor: props.id,
    isDisabled: props.disabled || false,
    isChecked: props.checked || false,
    children: [/*#__PURE__*/_jsx(HiddenCheckbox, _objectSpread(_objectSpread({}, props), {}, {
      type: type,
      checked: props.checked
    })), /*#__PURE__*/_jsx(CheckBorderBox, {
      children: /*#__PURE__*/_jsx(CheckMark, {
        checked: props.checked
      })
    }), /*#__PURE__*/_jsxs(ContentWrap, {
      children: [children && /*#__PURE__*/_jsx(Text, {
        as: "span",
        variant: props.disabled ? 'muted2' : 'primary',
        children: children
      }), description && /*#__PURE__*/_jsx(Text, {
        as: "span",
        variant: "muted",
        children: description
      })]
    })]
  });
};
var Wrap = styled.label.withConfig({
  componentId: "sc-8zte5g-0"
})(["display:flex;align-items:center;position:relative;border:1.5px solid ", ";border-radius:", ";background-color:", ";padding:", ";transition:border-color ", "ms ease-out;&:focus-within{border-color:", ";}", " ", ""], getColor('sandMedium'), getRadii('small'), getColor('base000'), getSpace('small4'), getDuration('interaction'), getColor('charcoal'), function (_ref2) {
  var isChecked = _ref2.isChecked,
      isDisabled = _ref2.isDisabled;

  if (isChecked && isDisabled) {
    return css(["border-color:", ";background-color:", ";"], getColor('gingkoLight'), getColor('gingkoLight'));
  } else if (isChecked && !isDisabled) {
    return css(["border-color:", ";background-color:", ";"], getColor('gingko'), getColor('gingko'));
  } else if (!isChecked && isDisabled) {
    return css(["border-color:", ";background-color:", ";"], getColor('sandLight'), getColor('sandLight'));
  }

  return css(["&:hover{border-color:", ";}"], getColor('stoneLight'));
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled;
  return !isDisabled && css(["cursor:pointer;"]);
});
var ContentWrap = styled.div.withConfig({
  componentId: "sc-8zte5g-1"
})(["display:flex;flex-direction:column;"]);
var CheckBorderBox = styled.div.withConfig({
  componentId: "sc-8zte5g-2"
})(["background-color:", ";border:1px solid;border-color:", ";border-radius:", ";flex-shrink:0;position:relative;margin-right:", ";height:", ";width:", ";"], getColor('base000'), getColor('sandDark'), getRadii('tiny'), pxToRem(10), getSpace('normal2'), getSpace('normal2'));
var CheckMark = styled(CheckIcon).withConfig({
  componentId: "sc-8zte5g-3"
})(["&&{color:", ";left:50%;position:absolute;top:50%;opacity:", ";transform:translate(-50%,-50%) scale(1.5);}"], getColor('base000'), function (_ref4) {
  var checked = _ref4.checked;
  return checked ? 1 : 0;
});
var HiddenCheckbox = styled.input.withConfig({
  componentId: "sc-8zte5g-4"
})(["height:0;width:0;opacity:0;position:absolute;&:disabled{&:checked + ", "{background-color:", ";border-color:", ";}&:not(:checked) + ", "{background-color:", ";border-color:", ";}& + ", " > ", "{color:", ";}}&:not(:disabled):checked{& + ", "{background-color:", ";border-color:", ";}}"], CheckBorderBox, getColor('wheat'), getColor('base200'), CheckBorderBox, getColor('base100'), getColor('base200'),
/* sc-selector */
CheckBorderBox, CheckMark, getColor('base1000'), CheckBorderBox, getColor('base1000'), getColor('base1000'));
export default Checkbox;